import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { Icon } from '@iconify/react';

// material
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { getTranslatedText } from '../pages/utils_v2/kumuHelper';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/InfoOutlined';

import { useMediaQuery, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

// ActivityCard.propTypes = {
//     activity: PropTypes.string.isRequired,
//     category: PropTypes.string.isRequired,
//     // options: PropTypes.array.isRequired,
//     // handleChange: PropTypes.func.isRequired
// };

export default function ActivityCard({ activity, activities, setActivities }) {

  const { i18n } = useTranslation('translation')
  const [isSelected, setIsSelected] = useState(false)
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const selected = activities?.some(
      item => item.id === activity.id
    )
    setIsSelected(selected)
  }, [activities, activity.id])

  const translatedName = getTranslatedText(i18n.language, activity.name);
  const isLongText = translatedName.length > 25;

  return (
    <Card 
        sx={{ position: 'relative', margin: 0.5, maxWidth: 'auto', minHeight: 140, backgroundColor: '#eaebed',  ':hover': { boxShadow: 5 }, border: isSelected ? 3 : 0, borderColor: isSelected ? '#6198EB' : 'none'  }}
        onClick={() => {
          if (isSelected) {
            // Remove from selected
            const filtered = activities.filter((a) => a.id !== activity.id);
            setActivities(filtered);
          } else {
            // Add to selected
            setActivities([...activities, activity]);
          }
          setIsSelected(!isSelected);
        }}
    >
      <CardContent sx={{ p: 0 }}>
        {isSelected ? 
        <IconButton
        sx={{
          position: "absolute",
          top: "-5px",
          left: "-5px",
        }}
        color="success"
        disableRipple
      >
         <Icon width={24} height={24} icon='carbon:checkmark-filled'/>
      </IconButton> : null}
        <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
            <p style={{
              fontSize: '1.45rem',
              textAlign: 'center',
              margin: 0,
              lineHeight: 1.4,
              width: '100%',
              // Clamp to 3 lines then ellipsis
              display: '-webkit-box',
              WebkitLineClamp: 5,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}>
              {translatedName}
            </p>
        </div>
        <div style={{ position: 'absolute', right: 4, bottom: 0 }}>
          <Tooltip
            open={tooltipIsOpen}
            onOpen={() => setTooltipIsOpen(true)}
            onClose={() => setTooltipIsOpen(false)}
            title={<p style={{ fontSize: '14px', width: '100%' }}>{activity.info}</p>}
            enterTouchDelay={0} 
            leaveTouchDelay={4000}
            disableHoverListener={isMobile}
            disableFocusListener={false}
            disableTouchListener={false}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: '260px',
                  padding: '10px 12px',
                  fontSize: '14px',
                },
              },
            }}
          >
            <IconButton 
              disableRipple 
              onClick={() => setTooltipIsOpen(!tooltipIsOpen)}>
                <Icon width={24} height={24} icon='ph:info'/>
            </IconButton>
          </Tooltip>
        </div>
      </CardContent>
    </Card>
  );
}